export function pluginSpecialHookHelper({ plugins = [] }: { plugins: any }) {
  return {
    composeOnCreateApp(
      AppComponent: React.ComponentType<any>,
      config: any,
    ): React.ComponentType<any> {
      return plugins.reduce((_AppComponent: any, plugin: any) => {
        const specialHook = plugin.__SPECIALHOOK__;
        return specialHook && specialHook.onCreateApp
          ? specialHook.onCreateApp(_AppComponent, config)
          : _AppComponent;
      }, AppComponent);
    },
  };
}
